module.exports = __webpack_public_path__ + "img/arrow-drop-up-fill@3x.e9f4fae7.svg";